@if (budgetSignal()) {
    <h4 class='text-center mb-2 d-flex flex-row w-100 justify-content-center'>
        {{ budgetSignal().budgetName }}&nbsp;|&nbsp;
        <span ngbTooltip='{{budgetSignal().fiscalYearStart | date:"M/d/yyyy"}} - {{budgetSignal().fiscalYearEnd | date:"M/d/yyyy"}}'>
            FY{{ budgetSignal().fiscalYearStart | date:'yy' }}/{{ budgetSignal().fiscalYearEnd | date:'yy' }}&nbsp;
        </span>
    </h4>
}

<div class='border rounded pt-2 px-3'>
    <div class='d-flex flex-wrap justify-content-between mb-2'>
        <div class='d-flex flex-column justify-content-start text-center align-items-start mt-2'>
            <button 
                class='btn btn-outline-success mb-2 btn-align'
                container='body'
                (click)='addPo()'
            >
                <fa-icon 
                    [icon]='faFileContract' 
                    size='xl' 
                />
                Add Purchase Order
            </button>

            <button 
                class='btn btn-outline-success mb-2 btn-align'
                container='body'
                (click)='addJournalEntry()' 
            >
                <fa-icon 
                    [icon]='faBookMedical' 
                    size='xl' 
                />
                Add Journal Entry
            </button>

            <button 
                class='btn btn-outline-success btn-align' 
                container='body'
                (click)='createInvoice()'
            >
                <fa-icon 
                    [icon]='faFileInvoiceDollar' 
                    size='xl' 
                />
                Add Invoice
            </button>
        </div>

        @if (budgetSignal()) {            
            @if (!kpiChart()) {
                <div class='d-flex flex-row justify-content-start w-50 mt-2'>
                    <div class='mr-4 d-flex flex-column'>
                        <button 
                            class='btn btn-primary mx-1'
                            ngbTooltip='Click to display the Budget Breakdown Graph.'
                            (click)='toggleKpiChart()' 
                        >
                            <fa-icon 
                                [icon]='faChartPieSimple' 
                                size='xl' 
                            />
                        </button>
                    </div>
            
                    <div class='d-flex flex-column w-75'>
                        <div class='d-flex flex-row justify-content-between'>
                            <span>
                                <b ngbTooltip='The selected budget name current allocation value.'>
                                    Allocations (A) :
                                </b>
                            </span>
                            <p class='text-right'>{{ allocations() | currency }}</p>
                        </div>
            
                        <div class='d-flex flex-row justify-content-between'>
                            <span>
                                <b ngbTooltip='The sum of all Reconciled Amount for all invoices and journal entries for ALL PO(s).
                                    If Reconciled Amount is not populated then the Invoice / Journal Entry Amount is calculated.'
                                >
                                    Expenditures YTD (B) :
                                </b>
                            </span>
                            <p class='text-right'>{{ expenditures() | currency }}</p>
                        </div>
                        
                        <div class='d-flex flex-row justify-content-between'>
                            <span>
                                <b ngbTooltip='All PO(s) current Value minus Expenditures.'>
                                    Remaining PO(s) Balance (C) :
                                </b>
                            </span>
                            <p class='text-right'>{{ remainingBalance() | currency }}</p>
                        </div>
            
                        <div class='d-flex flex-row justify-content-between'>
                            <span>
                                <b ngbTooltip='Percentage of the Remaining PO Balance (C) from Allocations (A).'>
                                    Remaining PO(s) Percent (D) :
                                </b>
                            </span>
                            <p class='text-right'>{{ remainingPercent() | percent }}</p>
                        </div>
            
                        <div class='d-flex flex-row justify-content-between border-top'>
                            <span class='pt-2'>
                                <b ngbTooltip='Allocations (A) minus Expenditures (B) minus Remaining PO(s) Balance (C)'>
                                    Available Budget (E) :
                                </b>
                            </span>
                            <p class='text-right pt-2'>{{ availableBudget() | currency }}</p>
                        </div>
                    </div>
                </div>
            } @else {
                <div 
                    id='graph-container' 
                    class='d-flex flex-row justify-content-center'
                >
                    <div class='mr-3'>
                        <button 
                            class='btn btn-primary mx-1 mt-2'
                            ngbTooltip='Click to display the Budget Breakdown List.'
                            container='body'
                            (click)='toggleKpiChart()' 
                        >
                            <fa-icon 
                                [icon]='faList' 
                                size='xl' 
                            />
                        </button>
                    </div>

                    <div id='chart-container'>
                        <canvas 
                            #budgetChart 
                            id='budgetChart'
                        >{{ chartData() }}</canvas>
                    </div>
                </div>
            }
        }

        <div class='d-flex flex-column text-center align-items-start mt-2'>
            <div class='d-flex flex-row justify-content-between'>
                <button 
                    class='btn btn-outline-primary mx-1'
                    container='body'
                    (click)='viewInvoices(null)'
                >View All Invoices for Budget</button>

                @if (ff.On()) {
                    <button 
                        class='btn btn-outline-{{(testingMode() ? "success" : "danger")}} mx-1'
                        [ngbTooltip]='(testingMode() ? "DIS" : "EN") + "ABLE PCG POWER MODE!!!"'
                        container='body'
                        (click)='toggleTestingMode()' 
                    >
                        <fa-icon 
                            [icon]='faLaptopCode' 
                            size='xl' 
                        />
                    </button>
                }
            </div>

            @if (testingMode()) {
                <div class='d-flex flex-column text-center mt-2'>
                    <h5 class='text-warning'>PCG Testing Values</h5>

                    <input 
                        class='btn btn-light border-secondary m-1 text-center' 
                        type='text'
                        [(ngModel)]='filters.testAllocation'
                        placeholder='Test Budget Allocations'
                        (change)='setTestingData()'
                    />

                    <input 
                        class='btn btn-light border-secondary m-1 text-center' 
                        type="text"
                        [(ngModel)]='filters.testMultiplier'
                        placeholder='Test PO Multiplier'
                        (change)='setTestingData()'
                    />

                    <button 
                        class='btn btn-outline-info m-1'
                        container='body'
                        (click)='setTestingData(true)'
                    >
                        Randomize Testing Data
                        <fa-icon [icon]='faRefresh' />
                    </button>
                </div>
            }
        </div>
    </div>
</div>

@if (filters.budgetId) {
    @if (!isMobile) {
        <br />
        <p-table 
            #dt
            [columns]="visibleColumns"
            [value]="poList"
            dataKey="poId"
            [rowHover]="true"
            [rows]="50"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
            [loading]="isLoading"
            [paginator]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [filterDelay]="500"
            [size]="'large'"
            stripedRows 
            sortField="poNumber"
            selectionMode="single"    
            [globalFilterFields]='searchColumns'
            [dt]="tableDts"
            [scrollable]="true"
            scrollHeight="650px"
        >
            <ng-template #caption>
                <div class="d-flex">
                    <p-multiselect 
                        class="pl-1"
                        display="chip" 
                        [options]="availableColumns" 
                        [(ngModel)]="visibleColumns" 
                        optionLabel="header" 
                        selectedItemsLabel="Show / Hide" 
                        [style]="{ 'min-width': '100px' }" 
                        placeholder="Choose Columns" 
                        (ngModelChange)='columnChange($event)'
                    />
                    
                    <p-button 
                        class="pl-1"
                        (click)="op.toggle($event)" 
                        icon="pi pi-info-circle" 
                        label="Legend" 
                        severity="help"
                    />
                    <p-popover #op>
                        @for (legendVm of legend; track legendVm.id) {
                            <div class='d-flex align-items-center'>
                                <div 
                                    class='square' 
                                    [ngStyle]="{'background-color': legendVm.colorCode}"
                                ></div>
                                <span> = {{ legendVm?.description }}</span>
                            </div>
                        }
                    </p-popover>

                    <p-button 
                        class="pl-1"
                        (click)="opp.toggle($event)" 
                        icon="pi pi-search" 
                        label="Filters" 
                        severity="warn"
                    />
                    <p-popover #opp>
                        <div>
                            <label class='for'>Is Active?</label>
                            <mat-button-toggle-group 
                                #isActiveFilter
                                [(ngModel)]="filters.isActive" 
                                [value]="filters.isActive"
                                (change)="
                                    this.filters.isActive = $event.value; 
                                    getList();
                                "
                            >
                                <mat-button-toggle 
                                    class="flex-fill" 
                                    [value]="true"
                                >Yes</mat-button-toggle>
                                <mat-button-toggle 
                                    class="flex-fill mx-2" 
                                    [value]="false"
                                >No</mat-button-toggle>
                                <mat-button-toggle 
                                    class="flex-fill" 
                                    value="null"
                                >All</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </p-popover>

                    <p-iconfield 
                        iconPosition="right" 
                        class="ml-auto"
                    >
                        <p-button 
                            icon="pi pi-external-link" 
                            label="Export" 
                            (click)="exportList()" 
                            class="pr-1"
                        />
                        <p-inputicon>
                            <i class="pi pi-search pl-2"></i>
                        </p-inputicon>
                        <input 
                            #searchValue
                            pInputText 
                            type="text" 
                            (input)="dt.filterGlobal($event.target.value, 'contains')" 
                            placeholder="Search..." 
                        />
                        <p-button 
                            class="pl-1"
                            label="Clear" 
                            [outlined]="true" 
                            icon="pi pi-filter-slash" 
                            (click)="clearFilters(dt, searchValue)" 
                        />
                    </p-iconfield>
                </div>
            </ng-template>

            <ng-template 
                #header 
                let-columns
            >
                <tr>
                    @for (col of columns; track col; let i = $index) {
                        <th 
                            [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                            [class]="col?.cellClass"
                        >
                            @if (col?.headerTooltip != "") {
                                <span 
                                    container='body' 
                                    class="ignoreTooltipStyle" 
                                    [ngbTooltip]="$safeNavigationMigration(col?.headerTooltip)"
                                >
                                    {{ col?.header }}
                                    @if (col?.field == "expendituresYtd") { <br />(B) }
                                    @else if (col?.field == "remainingPoBalance") { <br />(C) }
                                    @else if (col?.field == "remainingPoPercent") { <br />(D) }
                                </span>
                            } @else {
                                {{ col?.header }}
                                @if (col?.field == "poValue") { <br />(A) }
                            }
                            @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                        </th>
                    }
                </tr>
            </ng-template>

            <ng-template 
                #body 
                let-row
                let-columns="columns"
            >
                <tr>
                    @for (col of columns; track col) {
                        <td 
                            [class]="col?.cellClass"
                            [class.bg-warning]='row.belowPOLevelThreshold' 
                        >
                            @if (
                                col?.field == "poId"
                                && row.poId != 0
                            ) {
                                <p-button 
                                    icon="pi pi-external-link"
                                    (click)="
                                        $event.stopPropagation(); 
                                        viewInvoices(row.poId);
                                    " 
                                    severity="info" 
                                />
                            } @else if (col?.field == "poNumber") {
                                <a 
                                    (click)="editPo(row.poId)"
                                    class="text-decoration-none text-primary"
                                >{{ row.poNumber }}</a>
                            } @else if (col?.isCurrency) { {{ row[col?.field] | currency }} } 
                            @else if (col?.isPercent) { {{ row[col?.field] | percent: '1.2-2' }} } 
                            @else if (col?.field == "canDelete") {
                                @if (row.canDelete) {
                                    <p-button 
                                        icon="pi pi-trash"
                                        (click)="
                                            $event.stopPropagation(); 
                                            deletePo(row.poId);
                                        " 
                                        severity="danger" 
                                        [ngbTooltip]='!canDelete() ? "You do not have permission to delete this Purchase Order." : ""'
                                        [disabled]="!canDelete()"
                                    /> 
                                }
                            } @else { {{ row[col?.field] }} }
                        </td>
                    }
                </tr>
            </ng-template>

            <ng-template #emptymessage>
                <tr>
                    <td 
                        colspan="11" 
                        class="text-center"
                    >No records found.</td>
                </tr>
            </ng-template>
        </p-table>
    } @else {
        <br />
        <div class="d-flex mb-2 pl-3 pr-3">
            <p-button 
                class="pl-1"
                (click)="op.toggle($event)" 
                icon="pi pi-info-circle" 
                label="" 
                severity="help"
            />
            <p-popover #op>
                @for (legendVm of legend; track legendVm.id) {
                    <div class='d-flex align-items-center'>
                        <div 
                            class='square' 
                            [ngStyle]="{'background-color': legendVm.colorCode}"
                        ></div>
                        <span> = {{ legendVm?.description }}</span>
                    </div>
                }
            </p-popover>

            <p-button 
                class="pl-1"
                (click)="opp.toggle($event)" 
                icon="pi pi-search" 
                label="" 
                severity="warn"
            />
            <p-popover #opp>
                <div>
                    <label class='for'>Is Active?</label>
                    <mat-button-toggle-group 
                        #isActiveFilter
                        [(ngModel)]="filters.isActive" 
                        [value]="filters.isActive"
                        (change)="
                            this.filters.isActive = $event.value; 
                            getList();
                        "
                    >
                        <mat-button-toggle 
                            class="flex-fill" 
                            [value]="true"
                        >Yes</mat-button-toggle>
                        <mat-button-toggle 
                            class="flex-fill mx-2" 
                            [value]="false"
                        >No</mat-button-toggle>
                        <mat-button-toggle 
                            class="flex-fill" 
                            value="null"
                        >All</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </p-popover>
        </div>

        @for (row of poList; track row) {
            <div class="mb-4 flex items-center justify-center">
                <p-card class="p-card pl-3 pr-3">
                    <ng-template #header>
                        <div class="pb-2 p-card-header">
                            <h3 class="text-center">PO # {{ row.poNumber }}</h3>
                        </div>
                    </ng-template>

                    <ng-template #title>
                        <div>
                            <p-button 
                                icon="pi pi-external-link"
                                (click)="
                                    $event.stopPropagation(); 
                                    viewInvoices(row.poId);
                                " 
                                severity="info" 
                                label="View Invoices"
                            />
                        </div>
                    </ng-template>

                    <div [class.bg-warning]='row.belowPOLevelThreshold'>
                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Line #</div>
                            <div class="col-md-6 text-right">{{ row.lineNumber }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Vendor:</div>
                            <div class="col-md-6 text-right">{{ row.vendorName }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">PO Value (A):</div>
                            <div class="col-md-6 text-right">{{ row.poValue | currency }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Expenditures YTD (B):</div>
                            <div class="col-md-6 text-right">{{ row.expendituresYtd | currency }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">PO Balance (C):</div>
                            <div class="col-md-6 text-right">{{ row.remainingPoBalance | currency }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">PO % (D):</div>
                            <div class="col-md-6 text-right">{{ row.remainingPoPercent | percent }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Purchase Req #</div>
                            <div class="col-md-6 text-right">{{ row.purchaseReqNumber }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Purchase Req period:</div>
                            <div class="col-md-6 text-right">{{ row.purchaseReqPeriod }}</div>
                        </div>
                    </div>

                    <ng-template #footer>
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <p-button 
                                    icon="pi pi-external-link"
                                    label="Edit" 
                                    severity="info" 
                                    (click)="
                                        $event.stopPropagation(); 
                                        editPo(row.poId);
                                    "
                                />
                            </div>

                            <div class="col-md-6 text-right">
                                <p-button 
                                    icon="pi pi-trash"
                                    label="Delete" 
                                    severity="danger" 
                                    (click)="
                                        $event.stopPropagation();
                                        deletePo(row.poId);
                                    "
                                    [ngbTooltip]='!canDelete() ? "You do not have permission to delete this Purchase Order." : ""'
                                    [disabled]="!canDelete()"
                                />
                            </div>
                        </div>
                    </ng-template>
                </p-card>
            </div>
        }
    }
}